module.exports = __webpack_public_path__ + "static/media/MOF_exterior.0374b936.jpg";